import React, { useState } from "react";
import Check from "@material-ui/icons/Check";

import {
  CONSULTATION_TYPE_ABBREVIATION_SCOPOLAMINE_ADDON,
  ORDER_TYPE_SCOPOLAMINE_ADDON_4_PACK_MAIL_ORDER,
  ORDER_TYPE_SCOPOLAMINE_ADDON_10_PACK_MAIL_ORDER,
  ORDER_TYPE_SCOPOLAMINE_ADDON_4_PACK_VISIT_ONLY,
} from "~/shared/sharedConstants.js";

import GridContainer from "~/material-dashboard/components/Grid/GridContainer.jsx";
import GridItem from "~/material-dashboard/components/Grid/GridItem.jsx";
import Button from "~/material-dashboard/components/CustomButtons/Button.jsx";
import Card from "~/material-dashboard/components/Card/Card.jsx";
import CardBody from "~/material-dashboard/components/Card/CardBody.jsx";

import {
  getOrderItems,
  getVisitProduct,
  setConsultationTypeOrderItem,
} from "~/visits/utils/visitCookies";

import { isPharmacyPickupOrderType } from "~/shared/utils/sharedUtils";

import { kickNavy, kickBlue } from "~/shared/styles/baseStyles.js";

function getChoiceLabelStyle(isChecked) {
  return {
    width: "100%",
    padding: "12px 14px",
    border: `2px solid ${kickBlue}`,
    margin: "0 10px 16px",
    fontSize: "16px",
    fontWeight: "bold",
    cursor: "pointer",
    backgroundColor: isChecked ? kickBlue : "white",
    color: isChecked ? "white" : kickNavy,
  };
}

const mapRadioValueToOrderType = {
  "4pack": ORDER_TYPE_SCOPOLAMINE_ADDON_4_PACK_MAIL_ORDER,
  "10pack": ORDER_TYPE_SCOPOLAMINE_ADDON_10_PACK_MAIL_ORDER,
  visitOnly: ORDER_TYPE_SCOPOLAMINE_ADDON_4_PACK_VISIT_ONLY,
  no: null,
};

function mapOrderTypeToRadioValue(orderType) {
  switch (orderType) {
    case ORDER_TYPE_SCOPOLAMINE_ADDON_4_PACK_MAIL_ORDER:
      return "4pack";
    case ORDER_TYPE_SCOPOLAMINE_ADDON_10_PACK_MAIL_ORDER:
      return "10pack";
    case ORDER_TYPE_SCOPOLAMINE_ADDON_4_PACK_VISIT_ONLY:
      return "visitOnly";
    case null:
      return "no";
    default:
      return null;
  }
}

const ScopolamineAddon = ({ history, match }) => {
  const defaultSelectedOption = mapOrderTypeToRadioValue(
    getOrderItems()[CONSULTATION_TYPE_ABBREVIATION_SCOPOLAMINE_ADDON]
      ?.productSlug
  );

  const [selectedOption, setSelectedOption] = useState(defaultSelectedOption);

  const handleOptionChange = (e) => {
    // Save scopolamine order item to cookies
    setConsultationTypeOrderItem(
      CONSULTATION_TYPE_ABBREVIATION_SCOPOLAMINE_ADDON,
      mapRadioValueToOrderType[e.target.value]
    );
    setSelectedOption(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (["4pack", "10pack"].includes(selectedOption)) {
      // go to scopolamine addon questionnaire
      history.push(
        `/visits/${CONSULTATION_TYPE_ABBREVIATION_SCOPOLAMINE_ADDON}/1`
      );
    } else {
      history.push(
        `/visits/${match.params.consultationType}/payment/order-details`
      );
    }
  };

  return (
    <form style={{ backgroundColor: "#3F3F82" }} onSubmit={handleSubmit}>
      <GridContainer justifyContent="center">
        <GridItem xs={10} sm={10} md={8}>
          <h3
            style={{
              color: "#FFFFFF",
              fontFamily: "Spectral-SemiBold",
              fontSize: "32px",
              marginTop: "40px",
            }}
          >
            Add Scopolamine to your order?
          </h3>
          <p
            style={{
              color: "#FFFFFF",
              fontFamily: "BasisGrotesquePro-Regular",
              fontSize: "18px",
              lineHeight: "26px",
            }}
          >
            [TODO: finalize copy] Scopolamine works with beta blockers for an
            enhanced calming effect while keeping you feeling alert and focused.
          </p>
        </GridItem>
        <GridItem xs={12} sm={12} md={8}>
          <Card style={{ paddingTop: "30px", paddingBottom: "16px" }}>
            <CardBody
              style={{
                display: "flex",
                flexDirection: "column",
                padding: "0 2px",
              }}
            >
              <div
                style={{
                  maxWidth: "400px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  alignItems: "center",
                  margin: "0 10px",
                }}
              >
                <img
                  src="https://static8.depositphotos.com/1003131/1021/i/450/depositphotos_10214337-stock-photo-yellow-lab-puppy-in-the.jpg"
                  alt=""
                  style={{
                    width: "240px",
                    marginBottom: "20px",
                    borderRadius: "6px",
                    border: `1px solid ${kickBlue}`,
                    marginLeft: "10px",
                  }}
                />
                {isPharmacyPickupOrderType(getVisitProduct()) ? (
                  <label
                    style={getChoiceLabelStyle(selectedOption === "visitOnly")}
                  >
                    <input
                      type="radio"
                      value="visitOnly"
                      checked={selectedOption === "visitOnly"}
                      onChange={handleOptionChange}
                      style={{ display: "none" }}
                    />
                    $10 | Scopolamine (Prescription only)
                    {selectedOption === "visitOnly" && (
                      <Check
                        style={{
                          fontSize: "20px",
                          float: "right",
                          color: "white",
                        }}
                      />
                    )}
                  </label>
                ) : (
                  <>
                    <label
                      style={getChoiceLabelStyle(selectedOption === "4pack")}
                    >
                      <input
                        type="radio"
                        value="4pack"
                        checked={selectedOption === "4pack"}
                        onChange={handleOptionChange}
                        style={{ display: "none" }}
                      />
                      $30 | Scopolamine 4-pack
                      {selectedOption === "4pack" && (
                        <Check
                          style={{
                            fontSize: "20px",
                            float: "right",
                            color: "white",
                          }}
                        />
                      )}
                    </label>
                    <label
                      style={getChoiceLabelStyle(selectedOption === "10pack")}
                    >
                      <input
                        type="radio"
                        value="10pack"
                        checked={selectedOption === "10pack"}
                        onChange={handleOptionChange}
                        style={{ display: "none" }}
                      />
                      $50 | Scopolamine 10-pack
                      {selectedOption === "10pack" && (
                        <Check
                          style={{
                            fontSize: "20px",
                            float: "right",
                            color: "white",
                          }}
                        />
                      )}
                    </label>
                  </>
                )}
                <label style={getChoiceLabelStyle(selectedOption === "no")}>
                  <input
                    type="radio"
                    value="no"
                    checked={selectedOption === "no"}
                    onChange={handleOptionChange}
                    style={{ display: "none" }}
                  />
                  No, thanks
                  {selectedOption === "no" && (
                    <Check
                      style={{
                        fontSize: "20px",
                        float: "right",
                        color: "white",
                      }}
                    />
                  )}
                </label>
              </div>
            </CardBody>
          </Card>
          <Button
            disabled={!selectedOption}
            type="submit"
            style={{
              display: "block",
              backgroundColor: "#F25930",
              margin: "20px auto 30px auto",
              width: "300px",
              fontSize: "18px",
              fontWeight: "medium",
              textTransform: "unset",
            }}
          >
            Continue
          </Button>
        </GridItem>
      </GridContainer>
    </form>
  );
};

export default ScopolamineAddon;
